import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const FailContainer = styled.div`
  min-height: 100vh;
  background: #f8f9fa;
  padding-top: 100px;
  padding-bottom: 60px;
`;

const FailContent = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FailCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const FailIcon = styled.div`
  font-size: 64px;
  margin-bottom: 20px;
`;

const FailTitle = styled.h1`
  font-size: 32px;
  color: #d32f2f;
  margin-bottom: 15px;
`;

const FailMessage = styled.p`
  color: #666;
  font-size: 18px;
  margin-bottom: 30px;
  line-height: 1.6;
`;

const ErrorDetails = styled.div`
  background: #ffebee;
  border: 1px solid #ffcdd2;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 30px;
  color: #c62828;
  font-size: 14px;
`;

const Button = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #ff6b35 0%, #e55a2b 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 15px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 15px;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
  }
`;

const SecondaryButton = styled.button`
  width: 100%;
  background: transparent;
  color: #666;
  border: 2px solid #ddd;
  border-radius: 8px;
  padding: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #f5f5f5;
  }
`;

const PaymentFail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // Проверяем авторизацию
    if (!isAuthenticated()) {
      navigate('/login');
      return;
    }
  }, [navigate, isAuthenticated]);

  const handleRetry = () => {
    // Возвращаемся к корзине для повторной попытки оплаты
    navigate('/cart');
  };

  const handleGoHome = () => {
    navigate('/');
  };

  // Получаем информацию об ошибке из URL параметров
  const errorCode = searchParams.get('ErrorCode');
  const errorMessage = searchParams.get('ErrorMessage');

  return (
    <FailContainer>
      <FailContent>
        <FailCard>
          <FailIcon>❌</FailIcon>
          <FailTitle>Оплата не завершена</FailTitle>
          <FailMessage>
            К сожалению, произошла ошибка при обработке платежа. 
            Пожалуйста, попробуйте еще раз или выберите другой способ оплаты.
          </FailMessage>

          {(errorCode || errorMessage) && (
            <ErrorDetails>
              {errorCode && <div><strong>Код ошибки:</strong> {errorCode}</div>}
              {errorMessage && <div><strong>Описание:</strong> {errorMessage}</div>}
            </ErrorDetails>
          )}

          <div style={{ fontSize: '14px', color: '#666', marginBottom: '30px' }}>
            Если проблема повторяется, пожалуйста, свяжитесь с нашей службой поддержки.
          </div>

          <Button onClick={handleRetry}>
            Попробовать еще раз
          </Button>
          <SecondaryButton onClick={handleGoHome}>
            Вернуться на главную
          </SecondaryButton>
        </FailCard>
      </FailContent>
    </FailContainer>
  );
};

export default PaymentFail;




